import checkoutValidation from './slice.checkout'
import checkoutRates from './slice.checkoutRates'
import checkoutSessionToken from './slice.checkoutSessionToken'
import integrations from './slice.integrations'
import storeViews from './slice.storeViews'

export default { checkoutRates, checkoutSessionToken, checkoutValidation, integrations, storeViews }
